import React from 'react'
import { FaFacebook, FaInstagram, FaLinkedin,FaWhatsapp,FaGithub } from 'react-icons/fa'
import { SiGmail,SiFrontendmentor } from 'react-icons/si'
import { FooterContainer, FooterCV,FooterWrap,FooterLinksContainer,FooterCopy,FooterLinksWrapper,FooterHead,FooterLinkItems, FooterLinkTitle} from './FooterErrElements'
import { SocialMedia, SocialMediaWrap, WebsiteRights, SocialIcons, SocialIconLink,JimyyRamz } from './FooterErrElements'
const FooterErr = () => {
    return (
       <>
         <FooterContainer>
            <FooterWrap>
            <FooterHead>Espero que mi portafolio te haya agradado y llamado la atención.</FooterHead>
            <FooterLinkTitle>Te dejo mi CV listo para llevar</FooterLinkTitle>
                <FooterLinksContainer>
                    <FooterLinksWrapper>
                        <FooterLinkItems>
                          <FooterCV href="http://curriculum.eljimmyramz.com/assets/Ramirez_Osorio_Jaime_Ivan.pdf" download="CV Jaime Ivan Ramirez Osorio" rel="noopener noreferrer">Descargar CV</FooterCV>
                        </FooterLinkItems>
                    </FooterLinksWrapper>
                </FooterLinksContainer>
                <SocialMedia>
                    <SocialMediaWrap>
                        <SocialIcons>
                            <SocialIconLink href="https://www.facebook.com/eljimmyramz" target="_blank" aria-label="Facebook">
                                <FaFacebook />
                            </SocialIconLink>
                            <SocialIconLink href="https://www.linkedin.com/in/eljimmyramz/" target="_blank" aria-label="Linkedin">
                                <FaLinkedin />
                            </SocialIconLink>
                            <SocialIconLink href="https://www.instagram.com/eljimmyramz04/" target="_blank" aria-label="Instagram">
                                <FaInstagram />
                            </SocialIconLink>
                            <SocialIconLink href="https://api.whatsapp.com/send?phone=5215561433577&text=Hola!&nbsp;me&nbsp;puedes&nbsp;apoyar?" target="_blank" aria-label="WhatsApp">
                                <FaWhatsapp />
                            </SocialIconLink>
                            <SocialIconLink href="https://github.com/Jaime-4-1998" target="_blank" aria-label="GitHub">
                                <FaGithub />
                            </SocialIconLink>
                            <SocialIconLink href="https://www.frontendmentor.io/profile/Jaime-4-1998" target="_blank" aria-label="FrontendMentor">
                                <SiFrontendmentor />
                            </SocialIconLink>
                            <SocialIconLink href="mailto:ramirezjaime648@gmail.com" target="_blank" aria-label="Youtube">
                                <SiGmail />
                            </SocialIconLink>
                            
                        </SocialIcons>
                       
                    </SocialMediaWrap>
                  
                </SocialMedia>
            </FooterWrap>
            <FooterCopy>
              <WebsiteRights>CopyRight © {new Date().getFullYear()} por </WebsiteRights>
              <JimyyRamz href="https://www.instagram.com/eljimmyramz/" target="_blank" aria-label="Instagram">@eljimmyramz</JimyyRamz>
            </FooterCopy>
        </FooterContainer>
       </>
    )
}

export default FooterErr
